import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@env/environment';

export const domainInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) =>
{
    const url = req.url;

    if (url.includes(environment.domain))
    {
        return next(req.clone());
    }

    return next(req.clone({
        url: `${environment.domain}${url}`,
    }));
};
